import { shuffleArray } from "../../utilities/shuffle";

export class SessionReshuffler {
  constructor(module) {
    this.module = module;
  }

  reshuffle() {
    const parent = this.module.sessions[0].parentNode;
    const newItems = shuffleArray(Array.from(this.module.sessions));

    this.module.render(() => newItems.forEach((newItem) => parent.appendChild(newItem)));
  }
}
